import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface PageHeadlineProps {
  headlineKey: string;
  subheadlineKey?: string;
  children?: ReactNode;
  className?: string;
}

export function PageHeadline({
  headlineKey,
  subheadlineKey,
  children,
  className = '',
}: PageHeadlineProps) {
  const { t } = useTranslation();

  return (
    <div className={`flex items-center justify-between ${className}`}>
      <div>
        <h1 className="text-2xl font-bold text-onbackground">{t(headlineKey)}</h1>
        {subheadlineKey && (
          <p className="text-sm text-muted">{t(subheadlineKey)}</p>
        )}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}
